module.exports = {

  title: '智蜂制造',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * @type {string}
   * @description 全局图片域名配置
   */
  imageBaseUrl: 'https://fww.jpjjjq.com'
}
